import Const from 'src/config/Const';
import pathWithQueryString from './pathWithQueryString';

export type ImageFormatArgs = {
  width: number;
  height: number;
  quality: number;
  format: string;
};

/**
 * Utility to create a fully qualified URL to an image asset hosted by the CDN
 *
 * @param path The image's path in the CDN Google Cloud Storage bucket
 * @param format Arguments to format this image in the Nicephore CDN
 * @returns Fully qualified CDN URL to the image
 */
export default function cdn(path: string, format?: ImageFormatArgs): string {
  if (format) {
    return pathWithQueryString(`${Const.imageCdnUrl}/image/${path}`, format);
  }
  return `${Const.cdnUrl}/${path}`;
}
